import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon_chevronDown",
  "use": "icon_chevronDown-usage",
  "viewBox": "0 0 10 6",
  "content": "<symbol viewBox=\"0 0 10 6\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon_chevronDown\"><path d=\"M8.2.2a1 1 0 011.4 1.4l-4 4a1 1 0 01-1.4 0l-4-4A1 1 0 011.6.2l3.3 3.29L8.2.19V.2z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol